import { getEnabledFeedbackTypeNames, hasFeedbackPluginEnabledOverrides } from "./feedbackProjectPreferences";

export function getFeedbackSelectionPayload({
  installations = undefined,
  feedbackPreferences = undefined,
  feedbackTypeNamesOverride = undefined,
  selectedFeedbackCategory,
  feedbackTypeNamesForSelectedCategory = undefined,
  feedbackTypeNamesForAllCategories = undefined,
}) {
  if (hasFeedbackPluginEnabledOverrides(feedbackPreferences)) {
    if (feedbackTypeNamesForSelectedCategory === undefined && selectedFeedbackCategory) {
      feedbackTypeNamesForSelectedCategory = getEnabledFeedbackTypeNames(installations, feedbackPreferences, selectedFeedbackCategory);
    }
    if (feedbackTypeNamesForAllCategories === undefined) {
      feedbackTypeNamesForAllCategories = getEnabledFeedbackTypeNames(installations, feedbackPreferences);
    }
  }

  if (Array.isArray(feedbackTypeNamesOverride) && feedbackTypeNamesOverride.length > 0) {
    return {
      feedbackTypeNames: feedbackTypeNamesOverride,
      selectedCategory: null,
    };
  }

  if (feedbackTypeNamesOverride === null || (Array.isArray(feedbackTypeNamesOverride) && feedbackTypeNamesOverride.length === 0)) {
    if (Array.isArray(feedbackTypeNamesForAllCategories) && feedbackTypeNamesForAllCategories.length > 0) {
      return {
        feedbackTypeNames: feedbackTypeNamesForAllCategories,
        selectedCategory: null,
      };
    }
    return { selectedCategory: null };
  }

  if (Array.isArray(feedbackTypeNamesForSelectedCategory) && feedbackTypeNamesForSelectedCategory.length > 0) {
    return {
      feedbackTypeNames: feedbackTypeNamesForSelectedCategory,
      selectedCategory: null,
    };
  }

  return { selectedCategory: selectedFeedbackCategory };
}
